export default __webpack_public_path__ + "static/media/re.bd321c3d.svg";